import React, { useState } from 'react';
import { Button, Checkbox } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { BrandCheckbox } from './BrandCheckbox';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    margin: 0,
  },
  buttonText: {
    color: theme.palette.primary.main,
    padding: 0,
    margin: 0,
  },
  buttonCheckbox: {
    backgroundColor: theme.palette.background.default,
    height: theme.spacing(5),
    border: 'none',
    borderRadius: '40px',
    padding: 0,
    margin: 0,
    '&.MuiButton-root': {
      padding: 0,
      margin: 0,
    },
    '&.MuiButtonBase-root': {
      padding: 0,
      margin: 0,
    },
    '& .MuiCheckbox-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiCheckbox-root.Mui-checked': {
      color: theme.palette.primary.main,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    }
  }
}));

function BrandButtonCheckbox({ ...params}) {
  const [checked, setChecked] = useState(false);
  const classes = useStyles();

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <div className={classes.root}>
      <Button variant="text" className={classes.buttonCheckbox} {...params}>
            <BrandCheckbox
              checked={params.checked}
            />
            <div className={classes.buttonText}>
              {params.buttonText}
            </div>
      </Button>
    </div>
  );
}

export default BrandButtonCheckbox;
